import { slice } from '../slices/autocomplete';

const nameSpace = slice.name;

export const isLoading = (state: RootState) => state[nameSpace].isLoading;
export const autocompleteList = (state: RootState) => state[nameSpace].autocompleteList;
export const autocompleteListLoaded = (state: RootState) => state[nameSpace].autocompleteListLoaded;
